import { CanMatchFn, Router, CanActivateFn } from '@angular/router';
import { BsAuthService } from './bs-auth.service';
import { inject } from '@angular/core';
import { map, take } from 'rxjs/operators';
import { BsCacheService } from '../Cache/bs-cache.service';

export const authMatchGuard: CanMatchFn = (route, segments) => {
  const auth = inject(BsAuthService);
  const router = inject(Router);
  const bsCacheService = inject(BsCacheService);

  const attemptedUrl = '/' + segments.map(s => s.path).join('/');

  return auth.isAuthenticated().pipe(
    take(1),
    map(isAuth => {
      if (isAuth) return true;
      bsCacheService.setItem('redirectUrl', attemptedUrl);
      return router.parseUrl('/login');
    })
  );
};

export const authCanActivateGuard: CanActivateFn = (route, state) => {
  const auth = inject(BsAuthService);
  const router = inject(Router);
  const bsCacheService = inject(BsCacheService);
  return auth.isAuthenticated().pipe(
    take(1),
    map(isAuth => {
      if (isAuth) return true;
      return router.parseUrl('/login');
    })
  );
}
